import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { faSearch, faExclamationTriangle, faUser, faMapMarker, faLayerGroup, faInfoCircle, faRectangleLandscape, faCheck, faBan, faCircleNotch, faAngleLeft } from '@fortawesome/pro-regular-svg-icons';
import { TicketService } from '../services/ticket.service';

// get route
import { ActivatedRoute } from '@angular/router';

@Component({
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

    searchterm: string  = "";

    constructor(public auth: AuthService, public ticketService: TicketService, private route: ActivatedRoute) {}

    ngOnInit(){
        this.route.queryParams.subscribe(params => {
            if(params.tid) {
                setTimeout(() => {
                    this.ticketService.setActiveTicket(params.tid);
                }, 1000)
            }
        })
    }
    
    // icons
    search = faSearch;
    exclamationTriangle = faExclamationTriangle
    user = faUser;
    mapMarker = faMapMarker;
    layerGroup = faLayerGroup
    infoCircle = faInfoCircle;
    rectangleLandscape = faRectangleLandscape;
    check = faCheck;
    ban = faBan;
    circleNotch = faCircleNotch;
    angleLeft = faAngleLeft;
}
